module.exports = __webpack_public_path__ + "static/media/icon-panier.df0c200b.svg";